{
    "Administrator": "Administrateur :",
    "AdministratorRole": "Rôle d'administrateur :",
    "AdministratorLanguage_ServiceNotification": "Notification de service :",
    "AdministratorLanguage_ConcurrentSignins": "Les enseignes simultanées sont autorisées :",
    "NAME": "AdministratorLanguage"
}